import React from "react";
import { Bounce, toast } from "react-toastify";
import StarRating from "./StarRating";
const RightArrow = <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.67102 5.36399H13.5602L9.58399 1.38778C9.45957 1.2604 9.39086 1.08882 9.39295 0.910774C9.39504 0.732731 9.46778 0.562813 9.59516 0.438399C9.72253 0.313985 9.89412 0.245266 10.0722 0.247361C10.2502 0.249456 10.4201 0.322192 10.5445 0.449568L15.66 5.56503C15.7828 5.6903 15.8516 5.85872 15.8516 6.03413C15.8516 6.20955 15.7828 6.37797 15.66 6.50324L10.5445 11.6187C10.4155 11.7155 10.2558 11.7625 10.0949 11.751C9.93403 11.7396 9.78264 11.6705 9.66858 11.5564C9.55451 11.4424 9.48542 11.291 9.47398 11.1301C9.46255 10.9692 9.50954 10.8095 9.60633 10.6805L13.5602 6.70428H0.67102C0.493285 6.70428 0.32283 6.63368 0.197153 6.508C0.071476 6.38232 0.000871658 6.21187 0.000871658 6.03413C0.000871658 5.8564 0.071476 5.68595 0.197153 5.56027C0.32283 5.43459 0.493285 5.36399 0.67102 5.36399Z" fill="#3C3C42"/>
</svg>

const Card = ({ post, isConnected, showModal, setShowAPIModal, setCurrentAPIModalTab, setClickedAddon }) => {
	const showToast = (type, message, onClose = () => {}) => {
		toast[type](message, {
			position: "top-right",
			style: {
				margin: "30px 0 0 0",
				fontSize: "16px",
				fontWeight: "500",
				lineHeight: "26px",
				color: "#fff",
			},
			autoClose: 1000,
			onClose: onClose,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: false,
			progress: undefined,
			theme: "colored",
			transition: Bounce,
		});
	};

	const handleAddonAction = async (addon) => {
		if (!addon.slug) return;

		const isPro = addon.type === "Pro";
		const isBuyable = addon.status === "buyable";
		const needsLicense = addon.license === false;
		const isDeactivating = addon.status === "active";

		if (isPro && isBuyable && needsLicense) {
			setCurrentAPIModalTab("licenseVerification");
			setShowAPIModal(true);
			return;
		}
		easycommerce_modal(true);

		try {
			if (isPro && isDeactivating) {
				const response = await fetch(`${EASYCOMMERCE.rest_base}/addons/license`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"X-WP-Nonce": EASYCOMMERCE.nonce,
					},
					body: JSON.stringify({
						key: addon.token,
						addon: addon.slug,
						action: "deactivate",
						email: addon.email,
					}),
				});

				const licenseData = await response.json();

				if (!licenseData.success) {
					easycommerce_modal(false);
					showToast("error", licenseData.data?.message || "License deactivation failed");
					return;
				}
			}
			const res = await fetch(`${EASYCOMMERCE.rest_base}/addons`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": EASYCOMMERCE.nonce,
				},
				body: JSON.stringify({
					action: isDeactivating ? "deactivate" : "activate",
					addon: addon.slug,
				}),
			});

			const data = await res.json();
			easycommerce_modal(false);

			if (data.success && data.data.status) {
				showToast("success", data.data.message, () => window.location.reload());
			} else {
				showToast("error", data.data.message);
			}
		} catch (error) {
			easycommerce_modal(false);
			showToast("error", "Something went wrong. Please try again.");
		}
	};

	return (
		<div className="flex flex-col border border-ec-border rounded-lg hover:shadow-[2px_22px_54.6px_0px_#EFEBFF]">
			<a href={post.url} target="_blank">
				<img
					className="w-full h-auto rounded-t-lg"
					src={post.thumbnail}
					alt=""
				/>
			</a>
			<div className="p-4 h-full flex flex-col justify-between">
				<div>
					<a className="block mb-2" href="#">
						<h2 className="text-ec-title text-xl leading-[32px] font-medium font-inter">
							{post.name.slice(0, 30)}
						</h2>
					</a>
					<p className="text-ec-body font-inter text-sm leading-[24px] mb-3 line-clamp-2">
						{post.desc}
					</p>
				</div>
				<div className="flex items-center justify-between mb-4">
					<h2 className="text-ec-title text-xl leading-[32px] font-medium font-inter">
						{post.old_price && post.old_price !== false ? (
							<>
								<span className="text-xl text-ec-title font-bold">
									${post.old_price}
								</span>
								<span className="text-sm line-through text-ec-light-black ml-2">
									${post.price}
								</span>
							</>
						) : (
							<span className="text-xl text-ec-title font-bold">
								${post.price}
							</span>
						)}
					</h2>

					<div className="flex items-center text-yellow-500 text-sm font-medium">
						<StarRating rating={post.rating} />
					</div>
				</div>
				<div className="flex items-center justify-between">
					<a
						className="text-base leading-[26px] text-ec-body font-inter group ml-1 inline-flex items-center font-normal 
                            hover:text-ec-primary focus:text-ec-primary focus:shadow-none focus:outline-none 
                            active:text-ec-primary"
						target="_blank"
						href={post.url}>
						<span>Learn More</span>
						<span className="ml-1 relative w-[16px] h-[12px]">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 16 12"
								fill="none"
								className="w-full h-full absolute inset-0">
								<path
									d="M0.67102 5.36399H13.5602L9.58399 1.38778C9.45957 1.2604 9.39086 1.08882 9.39295 0.910774C9.39504 0.732731 9.46778 0.562813 9.59516 0.438399C9.72253 0.313985 9.89412 0.245266 10.0722 0.247361C10.2502 0.249456 10.4201 0.322192 10.5445 0.449568L15.66 5.56503C15.7828 5.6903 15.8516 5.85872 15.8516 6.03413C15.8516 6.20955 15.7828 6.37797 15.66 6.50324L10.5445 11.6187C10.4155 11.7155 10.2558 11.7625 10.0949 11.751C9.93403 11.7396 9.78264 11.6705 9.66858 11.5564C9.55451 11.4424 9.48542 11.291 9.47398 11.1301C9.46255 10.9692 9.50954 10.8095 9.60633 10.6805L13.5602 6.70428H0.67102C0.493285 6.70428 0.32283 6.63368 0.197153 6.508C0.071476 6.38232 0.000871658 6.21187 0.000871658 6.03413C0.000871658 5.8564 0.071476 5.68595 0.197153 5.56027C0.32283 5.43459 0.493285 5.36399 0.67102 5.36399Z"
									className="fill-[#3C3C42] group-hover:fill-ec-primary transition-all duration-300"
								/>
							</svg>
						</span>
					</a>
					<button
						className={`py-2 px-4 text-base 
							font-inter font-normal transition-all duration-300 ${
								post.status === "active"
									? "hover:bg-ec-primary border border-ec-primary rounded-md text-ec-primary hover:text-white"
									: "easycommerce-primary-button"
							}`}
						// onClick={() => {
						// 	setClickedAddon(post);
						// 	if (post.type === "Pro" || post.status === "active") {
						// 		handleAddonAction(post); 
						// 	} else {
						// 		isConnected ? handleAddonAction(post) : showModal();
						// 	}
						// }}
						onClick={() => {
							setClickedAddon(post);
							handleAddonAction(post);
						}}
					>
						{post.action_text}
					</button>

				</div>
			</div>
		</div>
	);
};

export default Card;
